import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class CustomerService {
  static async getServiceRequests(userId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_get_service_requests`, {
        method: 'POST',
        body: JSON.stringify({ p_customer_id: userId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching service requests:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async getVehicles(userId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_get_vehicles`, {
        method: 'POST',
        body: JSON.stringify({ p_customer_id: userId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching vehicles:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async createServiceRequest(requestData) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_create_service_request`, {
        method: 'POST',
        body: JSON.stringify(requestData),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error creating service request:', error);
      return { success: false, error: error.message };
    }
  }

  static async addVehicle(vehicleData) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_add_vehicle`, {
        method: 'POST',
        body: JSON.stringify(vehicleData),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error adding vehicle:', error);
      return { success: false, error: error.message };
    }
  }

  static async updateProfile(userId, profileData) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_update_profile`, {
        method: 'POST',
        body: JSON.stringify({
          p_user_id: userId,
          p_name: profileData.name,
          p_phone: profileData.phone,
          p_address: profileData.address,
        }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error updating profile:', error);
      return { success: false, error: error.message };
    }
  }

  static async getServiceHistory(userId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_get_service_history`, {
        method: 'POST',
        body: JSON.stringify({ p_customer_id: userId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching service history:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async getPaymentHistory(userId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_get_payment_history`, {
        method: 'POST',
        body: JSON.stringify({ p_customer_id: userId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching payment history:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async trackOrder(orderId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_track_order`, {
        method: 'POST',
        body: JSON.stringify({ p_order_id: orderId }),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error tracking order:', error);
      return { success: false, data: {}, error: error.message };
    }
  }

  static async getActiveOrders(userId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_get_active_orders`, {
        method: 'POST',
        body: JSON.stringify({ p_customer_id: userId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching active orders:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async trackShipmentByAWB(awbCode) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/customer_track_shipment`, {
        method: 'POST',
        body: JSON.stringify({ p_awb_code: awbCode }),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error tracking shipment:', error);
      return { success: false, data: {}, error: error.message };
    }
  }
}

